import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="min-h-[100dvh] grid place-items-center p-6 bg-bg-1">
      <div className="card max-w-sm p-6 text-center flex flex-col gap-3">
        <h1 className="text-xl font-semibold">Page not found</h1>
        <p className="text-sm text-fg-secondary">
          Check the URL, or head back home.
        </p>
        <Link to="/" className="btn-primary mt-2 self-center">
          Go home
        </Link>
      </div>
    </div>
  );
}
